import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generatePath } from 'react-router-dom';
import { Pagination, Response } from '@ui/src';
import { Agreement, AgreementStatus } from '../../types';
import { agreementApi } from '../services/agreements';
import ROUTES from '../../../../routes';

export interface AgreementsListState {
  values?: Agreement[];
  errorsList?: string;
  sort?: {
    sortProp: string;
    sortDir: string;
  };
  pagination?: Pagination;
  selectedRows: string[];
  takeCount?: number;
}

const initialState: AgreementsListState = {
  values: undefined,
  selectedRows: [],
};

export const agreementsListSlice = createSlice({
  name: 'agreementsList',
  initialState,
  reducers: {
    onSelectedRows: (state, action: PayloadAction<string[]>) => {
      state.selectedRows = action.payload;
    },
    setTakeCount: (state, action: PayloadAction<number>) => {
      state.takeCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      agreementApi.endpoints.getAgreements.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      agreementApi.endpoints.getAgreements.matchRejected,
      (state, action: any) => {
        state.values = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      agreementApi.endpoints.getAgreements.matchFulfilled,
      (state, action: PayloadAction<Response<Agreement>>) => {
        state.values = action.payload.data.edges.map((item) => ({
          ...item.node,
          status: item.node.archivedAt
            ? AgreementStatus.ARCHIVED
            : AgreementStatus.PUBLISHED,
          url: generatePath(ROUTES.AGREEMENTS_READ, {
            agreementId: item.node.id,
          }),
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      agreementApi.endpoints.changeAgreementsStatus.matchFulfilled,
      (
        state,
        action: {
          meta: {
            arg: {
              originalArgs: string[];
            };
          };
        },
      ) => {
        const nextAgreements = state.values?.map((item) => {
          const result = { ...item };

          if (action.meta.arg.originalArgs.find((id) => item.id === id)) {
            result.status = AgreementStatus.ARCHIVED;
          }

          return result;
        });

        state.values = nextAgreements;

        state.selectedRows = [];
      },
    );
  },
});

export const { onSelectedRows, setTakeCount } = agreementsListSlice.actions;

export default agreementsListSlice.reducer;
